import React from 'react';
import { Form, Input } from 'antd';
import { FormInstance, Rule } from 'antd/lib/form';

type Invitee = {
  name: string;
  email: string;
};

const VirtualTourGuestForm: React.FC<{
  form: FormInstance;
  existingGuests: Invitee[];
}> = ({ form, existingGuests = [] }) => {
  const invitees = [0, 1, 2];

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
  };

  const rules: Rule[] = [];

  const validateMessages = {
    types: {
      email: `Invalid email address`,
    },
  };

  const initialValues = {
    guests: invitees.map(() => ({ name: '', email: '' })),
  };

  (existingGuests || []).forEach((guest, i) => {
    initialValues.guests[i] = guest;
  });

  return (
    <Form
      {...layout}
      form={form}
      colon={false}
      name="form_in_modal"
      initialValues={initialValues}
      hideRequiredMark
      validateMessages={validateMessages}
    >
      <Form.List name="guests">
        {fields => (
            <div>
              {fields.map((field, index) => (
                <div key={index}>
                  <Form.Item
                    name={[field.name, 'name']}
                    fieldKey={[field.fieldKey, 'name']}
                    rules={rules}
                    label={<i className="fa fa-user fa-lg" />}
                  >
                    <Input placeholder="Client Name" />
                  </Form.Item>
                  <Form.Item
                    name={[field.name, 'email']}
                    fieldKey={[field.fieldKey, 'email']}
                    rules={[
                      {
                        type: 'email',
                      },
                    ]}
                    label={<i className="fa fa-envelope fa-lg" />}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>
                </div>
              ))}
            </div>
          )}
      </Form.List>
    </Form>
  );
};

export default VirtualTourGuestForm;
